import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject ,  Subject } from 'rxjs';
import { HttpClientHelperService } from '../core/http-client-helper.service';
import { CitGlobalConstantService } from '../core/cit-global-constants.service';
import { HttpParams } from '@angular/common/http';
import { LicenseSummaryResponseModel, AuthCodeEmailModel, RequestAuthCodeORVersionUpgradeModel, UserInfo } from './cit-license-summary.model';


@Injectable()
export class CitLicenseGeneratorService {
  public userinfoCache: UserInfo;
  private _userInfo: BehaviorSubject<UserInfo> = new BehaviorSubject<UserInfo>(null);
  public userInfoObservable: Observable<UserInfo> = this._userInfo.asObservable();

  constructor(
    private httpClient: HttpClientHelperService,
    private citGlobalConstants: CitGlobalConstantService

  ) {
    this.userinfoCache = new UserInfo();
  }

  public getLicenseDetailsForSoftwarekey(softwareKey: string): Observable<any> {

    return this.httpClient.getRequest(
      this.citGlobalConstants.getLicenseDetailsForSoftwareKeyUrl,
      { "softwareKey": softwareKey });

  }

  public getLicenseDetailsForUsbKey(usbKeySerialNumber: string): Observable<LicenseSummaryResponseModel | any> {

    return this.httpClient.getRequest(
      this.citGlobalConstants.getLicenseDetailsForUsbKey,
      { "usbKeySerialNumber": usbKeySerialNumber });

  }

  public getKeySerialNumberFirstPart(): Observable<any> {

    return this.httpClient.getRequest(
      this.citGlobalConstants.getKeySerialNumberFirstPart);

  }


  public sendAuthCodeviaEmail(authcodeEmail: AuthCodeEmailModel): Observable<any> {
    return this.httpClient.postJSONRequest(
      this.citGlobalConstants.sendAuthCodeviaEmail,
      authcodeEmail
    )
  }

  public sendEmailForVersionUpgradeORRequestAuthCode(authcodeEmailUpgrade: RequestAuthCodeORVersionUpgradeModel): Observable<any> {
    return this.httpClient.postJSONRequest(
      this.citGlobalConstants.sendEmailForVersionUpgradeORRequestAuthCode,
      authcodeEmailUpgrade
    )
  }


  public getRequestToken(token: string) {
    return this.httpClient.getRequest(
      this.citGlobalConstants.getUserInfoForRequestToken, { "requestToken": token }
    ).subscribe((data: UserInfo) => {
      console.info(data);
      if (data != null && data != undefined) {
        this.userinfoCache = data;
        this._userInfo.next(this.userinfoCache);
      }
      }, error => {
      this._userInfo.error(error);

    });
  }

  //public getSitesForSIteID(siteId) {
  //  return this.httpClient.getRequest(
  //    this.citGlobalConstants.getSitesForSIteID,
  //    { "siteid": siteId });
  //}

  public getDataForRequestUrl(url) {
    return this.httpClient.getRequest(url);
  }
}
